export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-myspace-2421e46206e5b51f9b3862dbbad7e6f8.svg";